import { Container as PixiContainer } from 'pixi.js'

const Container = () => new PixiContainer()

export default Container
